(function () {
	'use strict';

	angular
    .module('app.setup')
		.controller('supplierPortalConfig', supplierPortalConfig);

	supplierPortalConfig.$inject = ['$rootScope', '$scope', '$timeout', '$window', '$translate', '$experiments', 'supplierPortalConfigService', 'customerSettingService', 'supplyChainReportColumns', 'supplierAllowedColumnService', 'storeService'];

	function supplierPortalConfig($rootScope, $scope, $timeout, $window, $translate, $experiments, supplierPortalConfigService, customerSettingService, supplyChainReportColumns, supplierAllowedColumnService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;	
		vm.showWorkbench = $experiments.isEnabled('workbench');
		// remove after GA Supplier on hand quantity upload
		vm.showSupplierOnHandInventory = $experiments.isEnabled('react-supplier-on-hand-inventory');

		var optionGroups = {
			'SHORTAGES_BY_ITEM': 'LOB',
			'LINE_OF_BALANCE': 'LOB'
		};

		vm.groupOptions = {
			'LOB': {
				'type': 'switch',
				'ngModel': 'supplierLobDemandRows',
				'label': 'Allow Exporting of Supply and Demand Rows',
				'visibility': 'showSupplyAndDemandRowOption'
			}
		};

		vm.settings = {};
		vm.supplierPortalComponents = [];
		vm.existingSettings = [];
		vm.existingLobDemandRows = false;
		vm.supplierLobDemandRows = false;
		vm.isSettingsChanged = isSettingsChanged;
		vm.saveSupplierPortalConfigSettings = saveSupplierPortalConfigSettings;
		vm.hasValidSelection = hasValidSelection;
		vm.reportColumns = supplyChainReportColumns.getSupplierReportColumns();
		vm.reportGroupUniqueNames = getReportGroupUniqueNames();
		vm.uniqueColumnNames = getUniqueByType('idToName');
		vm.uniqueColumnIds = getUniqueByType('nameToId');
		vm.idsToName = getKeyByValue('idToName');
		vm.namesToId = getKeyByValue('nameToId');
		vm.targetKeys = getSelectedTargetList() || [];
		vm.restrictedKeys = getRestrictedKeys() || [];
		vm.backupTargetKeys = _.clone(vm.targetKeys);
		vm.dataSource = getSourceColumns();
		vm.transferBoxOption = {
			showSearch: true,
			titles: {
  			origin: 'Hidden Fields',
  			target: 'Available Fields'
			},
			render: function(obj) {
				return $translate.instant(obj.key);
			}
		};
		vm.selectedReportsOnly = false;
		vm.showSelectedReportColumns = showSelectedReportColumns;
		vm.showSupplyAndDemandRowOption = false; 
		vm.setSupplyAndDemandRowOption = setSupplyAndDemandRowOption;
		vm.isValidGroup = isValidGroup;
		vm.getGroupModel = getGroupModel;

		function getSupplierPortalComponents() {
			supplierPortalConfigService.getSupplierPortalComponents().then(function (responseData) {
				vm.supplierPortalComponents = responseData;
				if (vm.supplierPortalComponents) { 
					if (!vm.showWorkbench) {
						vm.supplierPortalComponents = _.filter(vm.supplierPortalComponents, function (b) {
							return b.id !== 'WORKBENCH';
						});
					}
					// remove after GA Supplier on hand quantity upload
					if (!vm.showSupplierOnHandInventory) {
						vm.supplierPortalComponents = _.filter(vm.supplierPortalComponents, function (b) {
							return b.id !== 'SUPPLIER_ON_HAND_INVENTORY';
						});
					}
					vm.supplierPortalComponents = _.groupBy(vm.supplierPortalComponents, function (supplierPortalComponent) {
						return supplierPortalComponent.area.displayName;
					});
					var supplierPortalOptionGrouping = {};
					angular.forEach(vm.supplierPortalComponents, function (groupValues, groupKey) {
						var groups = {};

						angular.forEach(groupValues, function (groupValue) {
							var groupName = optionGroups[groupValue.id] || groupValue.id;
							if (!groups[groupName]) {
								groups[groupName] = [groupValue];
							} else {
								groups[groupName].push(groupValue);
							}
						});
						supplierPortalOptionGrouping[groupKey] = groups;
					});
					vm.supplierPortalComponents = supplierPortalOptionGrouping;
				}
			});
		}

		function getSupplierPortalCustomerSettings() {
			customerSettingService.getCustomerSettings(['supplierPortalComponents', 'supplierLobDemandRows'], adminConfig.factory.id).then(function (settings) {
				if (typeof settings.supplierPortalComponents !== 'undefined') { 
					vm.existingSettings = settings.supplierPortalComponents.split(',');
					vm.existingSettings.forEach(function (componentId) {
						vm.settings[componentId] = true;
					});
				}
				if (typeof settings.supplierLobDemandRows !== 'undefined') {
					vm.existingLobDemandRows = settings.supplierLobDemandRows;
					vm.supplierLobDemandRows = settings.supplierLobDemandRows;
				}
				setSupplyAndDemandRowOption();
			});
		}

		function init() { 
			getSupplierPortalCustomerSettings();
			getSupplierPortalComponents();
		}

		init();

		function getSelectedConfigOptions() { 
			return _.keys(_.pickBy(vm.settings, function (value, key) { return value; }));
		}

		function isSettingsChanged() { 
			return isReportSelectionChanged() || isColumnSelectionChanged() || isSupplierDemandRowSelectionChanged();
		}

		function isReportSelectionChanged() { 
			var newSetting = _.sortBy(getSelectedConfigOptions());
			var existingSettings = _.sortBy(vm.existingSettings);
			return newSetting.toString() !== existingSettings.toString();
		}

		function isSupplierDemandRowSelectionChanged() {
			return vm.existingLobDemandRows !== vm.supplierLobDemandRows;
		}

		function isColumnSelectionChanged() { 
			var newTargets = _.sortBy(vm.targetKeys);
			var existingTargets = _.sortBy(vm.backupTargetKeys);
			return newTargets.toString() !== existingTargets.toString();
		}

		function saveSupplierPortalConfigSettings() { 
			if (isReportSelectionChanged() || isSupplierDemandRowSelectionChanged()) { 
				var customerSetting  = {};
				var newSettings = getSelectedConfigOptions();
				if (isReportSelectionChanged()) {
					customerSetting['supplierPortalComponents'] = newSettings.toString();
				}

				if (!vm.showSupplyAndDemandRowOption) {
					vm.supplierLobDemandRows = false;
				}

				if (vm.existingLobDemandRows !== vm.supplierLobDemandRows) {
					customerSetting['supplierLobDemandRows'] = vm.supplierLobDemandRows;
				}

				customerSettingService.saveCustomerSettings(customerSetting, adminConfig.factory.id).then(function () {
					saveColumnSettingsChanged();
					vm.existingSettings = newSettings;
					vm.existingLobDemandRows = vm.supplierLobDemandRows;
				});
			} else {
				saveColumnSettingsChanged();
			}
		}

		function saveColumnSettingsChanged() {
			var isColumnChanged = isColumnSelectionChanged();
			if (isColumnChanged) {
				var targetKeys = getTargetColumnIds();
				supplierAllowedColumnService.saveSupplierAllowedColumns(targetKeys).then(function () {
					vm.backupTargetKeys = _.cloneDeep(vm.targetKeys);
					globalConfig.user.allowedColumns['allowed'] = targetKeys;
				});
			}
			$rootScope.$emit('toast', {
				'message': 'Supplier connect settings updated',
				'success': true
			});
		}

		function hasValidSelection() {
			return getSelectedConfigOptions().length;
		}

		function getUniqueByType(type) {
			var names = [];
			angular.forEach(vm.reportColumns, function (group) {
				angular.forEach(group, function (values) {
					var reportColumnNames = Object.keys(values[type]);
					names = _.uniq(_.concat(names, reportColumnNames));
				});
			});
			return names;
		}

		function getKeyByValue(type) {
			var sourceColumns = {};
			angular.forEach(vm.reportColumns, function (group) {
				angular.forEach(group, function (values) {
					var reportColumnIdToName = values[type];
					angular.forEach(reportColumnIdToName, function (value, key) {
						if (sourceColumns[key]) {
							sourceColumns[key].push(value);
							sourceColumns[key] = _.uniq(sourceColumns[key]);
						} else {
							sourceColumns[key] = [value];
						}
					});
				});
			});
			return sourceColumns;
		}

		function getReportGroupUniqueNames() {
			var sourceColumns = {};
			angular.forEach(vm.reportColumns, function (group, groupKey) {
				sourceColumns[groupKey] = [];
				angular.forEach(group, function (values) {
					var reportColumnNames = Object.keys(values['idToName']);
					sourceColumns[groupKey] = _.uniq(_.concat(sourceColumns[groupKey], reportColumnNames));
				});
			});
			return sourceColumns;
		}

		function getSourceColumns() {
			var sourceColumns = [];
			angular.forEach(vm.uniqueColumnNames, function (columnName) {
				sourceColumns.push({
					key: columnName,
					isDefault: _.indexOf(vm.targetKeys, columnName)
				});
			});
			return _.sortBy(sourceColumns, ['key']);
		}

		function getSelectedTargetList() {
			var defaultSelected = [];
			var targetColumnIds = _.uniq(_.concat(globalConfig.user.allowedColumns['allowed'] || [], globalConfig.user.allowedColumns['default'] || []));
			angular.forEach(targetColumnIds, function (targetColumnId) {
				if (vm.namesToId[targetColumnId]) {
					defaultSelected = _.concat(defaultSelected, vm.namesToId[targetColumnId]);
				}
			});
			return _.uniq(defaultSelected);
		};

		function getTargetColumnIds() {
			var targetIds = [];
			angular.forEach(vm.targetKeys, function (targetKey) {
				if (vm.idsToName[targetKey]) {
					targetIds = _.concat(targetIds, vm.idsToName[targetKey]);
				}
			});
			return _.difference(_.uniq(targetIds), globalConfig.user.allowedColumns['default'] || []);
		}

		function getRestrictedKeys() {
			var defaultSelected = [];
			var targetColumnIds = _.uniq(globalConfig.user.allowedColumns['default'] || []);
			targetColumnIds = _.concat(targetColumnIds, supplyChainReportColumns.getRequiredColumns());

			angular.forEach(targetColumnIds, function (targetColumnId) {
				if (vm.namesToId[targetColumnId]) {
					defaultSelected = _.concat(defaultSelected, vm.namesToId[targetColumnId]);
				}
			});
			return _.uniq(defaultSelected);
		}

		function showSelectedReportColumns() {
			var sourceColumns = [];
			var columnsBucket = vm.selectedReportsOnly ? getSelectedReportGroupName() : vm.uniqueColumnNames;
			angular.forEach(columnsBucket, function (columnName) {
				sourceColumns.push({
					key: columnName,
					isDefault: _.indexOf(vm.targetKeys, columnName)
				});
			});
			vm.dataSource = _.sortBy(sourceColumns, ['key']);
		}

		function getSelectedReportGroupName() {
			var selectedColumns = [];
			_.forEach(getSelectedConfigOptions(), function (selectedReport) {
				if (vm.reportGroupUniqueNames[selectedReport]) { 
					selectedColumns = _.uniq(_.concat(selectedColumns, vm.reportGroupUniqueNames[selectedReport]));
				}
			});
			return selectedColumns;
		}

		function setSupplyAndDemandRowOption() {
			vm.showSupplyAndDemandRowOption = vm.settings['SHORTAGES_BY_ITEM'] || vm.settings['LINE_OF_BALANCE'];
		}

		function isValidGroup($groupName) {
			return vm.groupOptions[$groupName] != null;
		}

		function getGroupModel($groupName) {
			return vm.groupOptions[$groupName].ngModel;
		}
	}
})();